import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAdminList } from '../../actions/permissionsAction'

import ListAdminView from "../../containers/AdminUsers/ListAdmin/ListAdmin"

const ListAdmin = ({history}) => {
    const dispatch = useDispatch()
    const {listAdmin} = useSelector(state=>state.permissionsAdmin)
    useEffect(() => {
        dispatch(getAdminList())
    
      return () => {
        
      }
    }, [])
    
  return (
    <ListAdminView listAdmin={listAdmin} />
  )
}

export default ListAdmin